<app-help-page mainVideo="calculated-metrics"
               [tutorials]="['calculated-metrics']"
               [videos]="['calculated-metrics']"></app-help-page>
